document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.capabilities-section');

  sections.forEach((section) => {
    const capabilityBtns = section.querySelectorAll('.capability');
    const capabilityInfos = section.querySelectorAll('.capability-info');
    const capabilityInfosContainer = section.querySelector('.capability-infos');
    const capabilityInfosBg = section.querySelector('.capability-infos-bg');
    const capabilityInfosCloseBtn = section.querySelector(
      '.capability-infos__btn'
    );

    capabilityBtns.forEach((capability) => {
      capability.addEventListener('click', () => {
        const capabilityId = capability.getAttribute('data-id');

        capabilityBtns.forEach((capabilityBtn) => {
          if (capabilityBtn.getAttribute('data-id') === capabilityId) {
            capabilityBtn.classList.add('capability--active');
          } else {
            capabilityBtn.classList.remove('capability--active');
          }
        });

        capabilityInfos.forEach((capabilityInfo) => {
          if (capabilityInfo.getAttribute('data-id') === capabilityId) {
            capabilityInfosContainer.hidden = false;
            capabilityInfosBg.classList.add('capability-infos-bg--active');
            capabilityInfo.hidden = false;
            setTimeout(() => {
              capabilityInfosContainer.style.height =
                capabilityInfo.offsetHeight + 'px';
            }, 100);
          } else {
            capabilityInfo.hidden = true;
          }
        });
      });
    });

    function closePopup() {
      capabilityInfosContainer.hidden = true;
      capabilityInfosBg.classList.remove('capability-infos-bg--active');
      capabilityBtns.forEach((capabilityBtn) => {
        capabilityBtn.classList.remove('capability--active');
      });
    }

    if (capabilityInfosBg) {
      capabilityInfosBg.addEventListener('click', () => {
        closePopup();
      });
    }

    if (capabilityInfosCloseBtn) {
      capabilityInfosCloseBtn.addEventListener('click', () => {
        closePopup();
      });
    }

    initDots(section, '.capability__line-dot');
    initDots(section, '.capability__circle-dot');
  });

  function initDots(section, dotClass) {
    const dots = Array.from(section.querySelectorAll(dotClass)).filter(
      (dot) => dot.offsetParent !== null
    );

    if (dots.length === 0) return;

    let activeDotIndex = 0;
    let prevActiveDotIndex = 0;

    function incrementActiveDot() {
      activeDotIndex = activeDotIndex + 1;
      if (activeDotIndex > dots.length - 1) activeDotIndex = 0;

      prevActiveDotIndex = activeDotIndex - 3;
      if (prevActiveDotIndex < -2) prevActiveDotIndex = dots.length - 3;
      if (prevActiveDotIndex < -1) prevActiveDotIndex = dots.length - 2;
      if (prevActiveDotIndex < 0) prevActiveDotIndex = dots.length - 1;

      if (dots[activeDotIndex])
        dots[activeDotIndex].classList.add('capability__dot--active');
      if (dots[prevActiveDotIndex])
        dots[prevActiveDotIndex].classList.remove('capability__dot--active');
    }

    setInterval(incrementActiveDot, 130);
  }
});
